export class RestClientNetworkError extends Error {
    constructor(message, response) {
        super(message);
        this.name = 'RestClientNetworkError';
        this.response = response;
    }
}
